<template>
  <div class="floor6-wrapper">
    <div class="floor6-title">
      <div class="floor6-title-img"><img src="~images/floor6/title.png" alt=""></div>
      <div class="floor6-title-content"><img src="~images/floor6/content.png" alt=""></div>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped lang="less">
.floor6-wrapper{
  width: 100%;
  height: 100%;
  background-image: url(~images/floor6/bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  min-width: 1200px;
  .floor6-title{
    position: absolute;
    top: 20%;
    left: 50%;
    width: 85%;
    transform: translate(-50%, 0);
    .floor6-title-img{
      width: 19.3%;
      img{
        width: 100%
      }
    }
    .floor6-title-content{
      margin-top: 2%;
      width: 100%;
      img{
        width: 100%
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/floor/floor_6.vue